import { ReactNode } from "react";
import { useIsIframe } from "@/hooks/useIsIframe";

interface IframeOnlyProps {
  children: ReactNode;
  fallback?: ReactNode;
}

const IframeOnly = ({ children, fallback = null }: IframeOnlyProps) => {
  const isIframe = useIsIframe();

  return <>{isIframe ? children : fallback}</>;
};

export default IframeOnly;
